  <div class="example-sidenav-div">
    <div class="vertcal-label above">MESSAGE</div>
      <button mat-icon-button
          class="tray-toggle-button"
              [matTooltip]="isVisible ? 'Close message tray' : 'Open message tray'"
              matTooltipPosition="left"
              (click)="toggleButton()">
        <mat-icon>
          {{ isVisible ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}
        </mat-icon>
      </button>
    <div class="vertcal-label below">TRAY</div>
  </div>
